import { render } from "./EditChampsLibrePage.vue?vue&type=template&id=8edeadaa&ts=true"
import script from "./EditChampsLibrePage.vue?vue&type=script&lang=ts"
export * from "./EditChampsLibrePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__